import type { ToolUseItem } from '@heidi/agents/contracts';
import type { ReactNode } from 'react';

import { SessionRecordingInlineBlock } from './SessionRecordingInlineBlock';

export const renderSessionRecordingToolUse = (item: ToolUseItem): ReactNode => (
  <SessionRecordingInlineBlock item={item} />
);
